import { PureComponent, Fragment } from 'react';
import { debounce } from 'lodash-es';
import cn from 'classnames';

import WithScroll from 'hocs/WithScroll';
import Portal from 'components/Portal';
import Preview from '../Preview/Preview';
import TemplatesBlock from './components/TemplatesBlock';
import { makeTemplatesIterator } from '../../fn/templatesIterator';

const THRESHOLD_TO_MORE = 200;

class TemplatesList extends PureComponent {
  constructor(props) {
    super(props);
    this.iterator = makeTemplatesIterator([...this.props.templates]);
    this.handleScrollToMore = debounce(this.handleScrollToMore, 100);
  }

  state = {
    previewTemplate: false,
    blocks: [],
    loading: false,
    isIteratorDone: false,
  };

  componentWillMount() {
    this.props.scroll.addListener('scroll', this.handleScrollToMore);
  }

  componentWillUnmount() {
    this.props.scroll.removeListener('scroll', this.handleScrollToMore);
  }

  componentDidMount() {
    this.getMoreTemplates();
  }

  handleBlockLoad = () => {
    this.setState({ loading: false }, this.props.scroll.update);
  };

  handleScrollToMore = () => {
    if (!this.listRef) return;

    if (this.state.loading) return;

    const { bottom } = this.listRef.getBoundingClientRect();
    const vheight = window.innerHeight || document.documentElement.clientHeight;
    if (bottom - THRESHOLD_TO_MORE < vheight) {
      this.getMoreTemplates();
    }
  };

  getMoreTemplates = () => {
    if (this.state.loading) return;

    const nextTemplates = this.iterator.next().value;

    if (!nextTemplates || !nextTemplates.length) return;

    this.setState(state => ({
      blocks: [...state.blocks, nextTemplates],
      loading: true,
      isIteratorDone: isIteratorDone(
        state.blocks,
        nextTemplates,
        this.props.templates
      ),
    }));
  };

  togglePreview = (template = false) => {
    this.setState({ previewTemplate: template });
  };

  render() {
    const { previewTemplate, blocks, loading, isIteratorDone } = this.state;

    const wrapperClasses = cn('wrapper', {
      'can-loading': !isIteratorDone || (isIteratorDone && loading),
    });

    return (
      <Fragment>
        <article className="section__article">
          <section className="section section_templates-all">
            <div className={wrapperClasses} ref={node => (this.listRef = node)}>
              {blocks.map((templates, key) => (
                <TemplatesBlock
                  templates={templates}
                  key={key}
                  onLoad={this.handleBlockLoad}
                  onSelect={this.togglePreview}
                />
              ))}
            </div>
          </section>
        </article>
        {previewTemplate && (
          <Portal>
            <Preview template={previewTemplate} onClose={this.togglePreview} />
          </Portal>
        )}
      </Fragment>
    );
  }
}

export default WithScroll(TemplatesList);

const isIteratorDone = (blocks, nextTemplates, allTemplates) => {
  const showedTemplatesCount =
    blocks.reduce((acc, block) => acc + block.length, 0) + nextTemplates.length;

  return showedTemplatesCount === allTemplates.length;
};
